import { render, staticRenderFns } from "./ConfettiOne.vue?vue&type=template&id=6f78c21c&scoped=true&lang=pug&"
import script from "./ConfettiOne.vue?vue&type=script&lang=js&"
export * from "./ConfettiOne.vue?vue&type=script&lang=js&"
import style0 from "./ConfettiOne.vue?vue&type=style&index=0&id=6f78c21c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f78c21c",
  null
  
)

export default component.exports